import { render } from "./EditMetaModal.vue?vue&type=template&id=4d0d81c0&scoped=true"
import script from "./EditMetaModal.vue?vue&type=script&lang=js"
export * from "./EditMetaModal.vue?vue&type=script&lang=js"

import "./EditMetaModal.vue?vue&type=style&index=0&id=4d0d81c0&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0d81c0"]])

export default __exports__